import {HasFunId} from "@/model/ThingModel";
import _ from "lodash";

enum InstrStatus {
    WAIT,
    SUCCESS,
    FAIL
}

export default interface Instruction extends HasFunId {
    args: Array<string>;
    status: InstrStatus;
    success: boolean;
}

export class BaseInstr implements Instruction {
    funId!: number
    args!: Array<string>
    status!: InstrStatus

    get success(): boolean {
        return this.status == InstrStatus.SUCCESS
    }

    private readonly FUN_ID_INDEX = 1
    private readonly STATUS_INDEX: number

    private get NON_ARGS_INDEXES(): Array<number> {
        return [this.FUN_ID_INDEX, this.STATUS_INDEX]
    }

    constructor(rawList: Array<string>) {
        this.STATUS_INDEX = rawList.length - 1

        this.funId = Number(rawList[this.FUN_ID_INDEX])
        this.status = Number(_.last(rawList))
        this.args = _.filter(rawList, (_, index) => {
            return !this.NON_ARGS_INDEXES.includes(index)
        })
    }
}

class StdInstr extends BaseInstr {
    constructor(rawList: Array<string>) {
        super(rawList);
    }
}

export class InstrUtil {
    static parseFromMessageBody(body: string): Instruction {
        return new StdInstr(InstrUtil.messageBodyToArr(body))
    }

    private static messageBodyToArr(body: string): Array<string> {
        return _.trimEnd(_.trimStart(body, '{'), '}')
            .split(",")
    }
}
